import { createFileRoute } from '@tanstack/react-router'

// The job's people are the stack's level 1, rendered by the section from this param; the report tabs are its children.
export const Route = createFileRoute('/_app/dev-resources/transitions/jobs/$jobId')({})
